// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a34e0bf8","455":"28d92de8","644":"66e86b27"}[chunkId] + ".chunk.js";
};